import { useContext } from 'react';
import WalletAssetsContext from '../contexts/WalletAssetsContext';

const useWalletAssets = () => useContext(WalletAssetsContext);

export default useWalletAssets;
